'use strict';

var baseListenerDataExtention = function () {
	return {
		__listeners: {
			enumerable: false,
			configurable: false,
			value: [],
		},
	};
};
var baseListenerExtention = {
	__notifyListeners: {
		value: function (fnName, args) {
			this.__listeners.forEach(function (handler) {
				handler(this, fnName, args);
			}, this);
		},
	},
	onChange: {
		value: function (handler) {
			if (this.__listeners.indexOf(handler) === -1) {
				this.__listeners.push(handler);
			}
			return function () {
				var index = this.__listeners.indexOf(handler);
				if (index !== -1) {
					this.__listeners.splice(index, 1);
				}
			}.bind(this);
		},
	},
	changed: {
		value: function () {
			this.__notifyListeners(this, 'changed');
		},
	},
};

var solutionBulderDataObjectExtention = function () {
	var entityClassName, entityType, objectId, sourceId;

	return {
		objectId: {
			enumerable: false,
			configurable: false,
			get: function () {
				return objectId;
			},
			set: function (value) {
				objectId = value || '';
			},
		},
		entityClassName: {
			enumerable: false,
			configurable: false,
			get: function () {
				return entityClassName;
			},
			set: function (value) {
				entityClassName = value || '';
			},
		},
		entityType: {
			enumerable: false,
			configurable: false,
			get: function () {
				return entityType;
			},
			set: function (value) {
				entityType = value || '';
			},
		},
		sourceId: {
			enumerable: false,
			configurable: false,
			get: function () {
				return sourceId;
			},
			set: function (value) {
				sourceId = value || '';
			},
		},
	};
};

function DataModelObject() {
	Object.defineProperties(this, baseListenerDataExtention());
}

DataModelObject.prototype = Object.create({}, baseListenerExtention);

function DataModelArray(data) {
	Object.defineProperties(this, baseListenerDataExtention());
	this.set(data);
}

DataModelArray.prototype = Object.create(Array.prototype, baseListenerExtention);

['push', 'pop', 'shift', 'splice', 'unshift', 'reverse', 'sort'].forEach(function (fnName) {
	DataModelArray.prototype[fnName] = function () {
		return function (fnName) {
			var res,
				args = Array.prototype.slice.call(arguments, 1),
				arrayFn = Array.prototype[fnName];

			if (arrayFn) {
				res = arrayFn.apply(this, args);
				this.__notifyListeners(fnName, args);
			}
			return res;
		}
			.bind(this, fnName)
			.apply(this, Array.prototype.slice.call(arguments, 0));
	};
});

DataModelArray.prototype.set = function (data) {
	if (data instanceof DataModelArray) {
		this.splice.apply(this, [0, this.length].concat(Array.prototype.slice.call(data, 0)));
	} else if (Array.isArray(data)) {
		this.splice.apply(this, [0, this.length].concat(data));
	}
};

DataModelArray.prototype.slice = function () {
	var args = Array.prototype.slice.call(arguments, 0);
	var newArr = new DataModelArray(Array.prototype.slice.apply(this, args));
	return newArr;
};

DataModelArray.prototype.concat = function () {
	var args = Array.prototype.slice.call(arguments, 0);
	var pureArray = Array.prototype.slice.call(this, 0);
	var newArr = new DataModelArray(pureArray.concat.apply(pureArray, args));
	return newArr;
};

DataModelArray.prototype.toJSON = function () {
	return Array.prototype.slice.call(this, 0);
};

function DataModelMultiFragmentArray(data, options) {
	DataModelArray.call(this, data);
	Object.defineProperties(this, solutionBulderDataObjectExtention());

	if (typeof options === 'object' && options) {
		this.entityType = options.entityType || '';
		this.entityClassName = options.entityClassName || '';
		this.objectId = options.objectId || '';
		this.sourceId = options.sourceId || '';
	}
}

DataModelMultiFragmentArray.prototype = Object.create(DataModelArray.prototype);

DataModelMultiFragmentArray.prototype.set = function (data, options) {
	DataModelArray.prototype.set.call(this, data);
	if (options && options.objectId) {
		this.objectId = options.objectId;
	}
};

DataModelMultiFragmentArray.prototype.slice = function () {
	var args = Array.prototype.slice.call(arguments, 0);
	var newArr = new DataModelMultiFragmentArray(Array.prototype.slice.apply(this, args));
	newArr.entityType = this.entityType;
	newArr.entityClassName = this.entityClassName;
	newArr.objectId = this.objectId;
	return newArr;
};
DataModelMultiFragmentArray.prototype.concat = function () {
	var args = Array.prototype.slice.call(arguments, 0);
	var pureArray = Array.prototype.slice.call(this, 0);
	var newArr = new DataModelMultiFragmentArray(pureArray.concat.apply(pureArray, args));
	newArr.entityType = this.entityType;
	newArr.entityClassName = this.entityClassName;
	newArr.objectId = this.objectId;
	return newArr;
};

var RelationCardinality = {
	ManyToZeroOne: 61443,
	ManyToOne: 61440,
	ManyToMany: 1,
	OneToOneZero: 61442,
	OneToMany: 0,
	OneZeroToOne: 2,
	OneZeroToMany: 3,
	OneToOne: 4,
	NoRelation: 5,
};

function RelationsConfig(options) {
	options = typeof options === 'object' && options !== null ? options : {};
	Object.defineProperties(this, {
		cardinality: {
			value: options.RelationCardinality || RelationCardinality.OneToMany,
		},
		referenceFrom: {
			value: typeof options.ReferenceFrom === 'string' ? options.ReferenceFrom : '',
		},
		attributeFrom: {
			value: typeof options.AttributeFrom === 'string' ? options.AttributeFrom : '',
		},
		referenceTo: {
			value: typeof options.ReferenceTo === 'string' ? options.ReferenceTo : '',
		},
		attributeTo: {
			value: typeof options.AttributeTo === 'string' ? options.AttributeTo : '',
		},
	});
	Object.freeze(this);
}
RelationsConfig.prototype = {
	createRelation: function () {
		return new Relation(this);
	},
	otherSideIsMany: function () {
		return this.cardinality === RelationCardinality.ManyToMany || this.cardinality === RelationCardinality.OneZeroToMany || this.cardinality === RelationCardinality.OneToMany;
	},
	thisSideIsMany: function () {
		return this.cardinality === RelationCardinality.ManyToMany || this.cardinality === RelationCardinality.ManyToZeroOne || this.cardinality === RelationCardinality.ManyToOne;
	},
	otherSideIsSingle: function () {
		return (
			this.cardinality === RelationCardinality.ManyToZeroOne ||
			this.cardinality === RelationCardinality.ManyToOne ||
			this.cardinality === RelationCardinality.OneZeroToOne ||
			this.cardinality === RelationCardinality.OneToOneZero
		);
	},
};

function Relation(relationsConfig) {
	if (!(relationsConfig instanceof RelationsConfig)) {
		throw Error('Relation cannot be created without correct RelationsConfig');
	}
	var addedRelations = [],
		removedRelations = [],
		fragmentId;

	Object.defineProperties(this, baseListenerDataExtention());

	Object.defineProperties(this, {
		fragmentId: {
			get: function () {
				return fragmentId;
			},
			set: function (newValue) {
				if (mx.components.Utils.isGuid(newValue)) {
					fragmentId = newValue;
				}
			},
		},
		relationsConfig: {
			value: relationsConfig,
		},
		addedRelations: {
			get: function () {
				return addedRelations;
			},
			set: function (newValue) {
				if (Array.isArray(newValue)) {
					addedRelations.splice.apply(addedRelations, [0, addedRelations.length].concat(newValue));
				}
			},
		},
		removedRelations: {
			get: function () {
				return removedRelations;
			},
			set: function (newValue) {
				if (Array.isArray(newValue)) {
					removedRelations.splice.apply(removedRelations, [0, removedRelations.length].concat(newValue));
				}
			},
		},

		//properties for request
		AddedRelations: {
			enumerable: true,
			get: function () {
				return addedRelations;
			},
			set: function (newValue) {
				if (Array.isArray(newValue)) {
					addedRelations = newValue;
					this.__notifyListeners('AddedRelations', [newValue]);
				}
			},
		},
		RemovedRelations: {
			enumerable: true,
			get: function () {
				return removedRelations;
			},
			set: function (newValue) {
				if (Array.isArray(newValue)) {
					removedRelations = newValue;
					this.__notifyListeners('RemovedRelations', [newValue]);
				}
			},
		},
	});
}

Relation.prototype = {
	set: function (data, options) {
		options = options || {};
		data = data || {};

		var previousId = this.fragmentId;

		this.fragmentId = options.fragmentId;

		this.addedRelations = data.AddedRelations;
		this.removedRelations = data.RemovedRelations;
		this.Count = data.Count;

		if (this.fragmentId && this.fragmentId !== previousId) {
			this.__notifyListeners('fragmentId', [this.fragmentId]);
		}
	},
	initNewChanges: function (changes) {
		var changed = false;
		if (typeof changes === 'object') {
			if (Array.isArray(changes.AddedRelations)) {
				this.AddedRelations = changes.AddedRelations.slice();
				changed = true;
			}
			if (Array.isArray(changes.RemovedRelations)) {
				this.RemovedRelations = changes.RemovedRelations.slice();
				changed = true;
			}
		}
		return changed;
	},
	changedInternal: function () {
		this.__notifyListeners('changedInternal');
	},
	_itemsToString: function (items) {
		return items
			.map(function (item) {
				return "'" + item + "'";
			})
			.join(',');
	},
};
Object.defineProperties(Relation.prototype, baseListenerExtention);

const mxOriginalIsArray = Array.isArray;
Array.isArray = function (arg) {
	return mxOriginalIsArray.call(undefined, arg) || arg instanceof DataModelArray;
};

export { DataModelArray, DataModelObject, DataModelMultiFragmentArray, RelationsConfig, Relation, RelationCardinality };
